import { Component, input } from "@angular/core";

@Component({
  template: ''
})
export abstract class AbstractUserApiModalComponent {
  readonly appColor = input("unset");
}
